import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { ICaseDocumentModel } from "../../../models/Cases/CaseDetailsModel";
import PDFIcon from "../../../images/pdf-icon-main.svg";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../../utils/Utils";
import { toast } from "react-toastify";
import Service from "../../../services";
// import FileViewer from "../../../commonfields/FileViewer";
import FileViewer from '../../../commonfields/ReactFileViewer';
import { catchErrorGeneric, fileFormatSupported } from "../../../utils/GeneralUtils";

interface ICaseDocumentsProps {
  caseDocuments: ICaseDocumentModel[];
  caseDocumentsSearch: string;
  handleCaseDocumentsSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CaseDocuments = (props: ICaseDocumentsProps) => {
  console.log("props", props);
  const service = new Service();
  const { caseDocuments, caseDocumentsSearch, handleCaseDocumentsSearch } =
    props;
  const [fileViewerToShow, setFileViewerToShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState<any>();

  const fileViewerHandler = (documentId: string) => {
    setLoader(true);
    setFileViewerToShow(true);
    if (documentId) {
      service.getCaseDocumentFile(documentId).then((response: AxiosResponse) => {
        if (fileFormatSupported(response?.data?.fileType)) {
          setFile({
            ...response?.data,
            uri: response?.data?.image
          })
        } else {
          toast.error("FileView is not supported")
        }

        setLoader(false)
      }).catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false)
      });
    } else {
      setLoader(false);
      // toast.error("Something went wrong")
      catchErrorGeneric("Something went wrong");
    }
  };

  const cancelFileViewHandler = () => {
    setFileViewerToShow(false);
    setFile(null);
  };

  return (
    <div className="caseDocumentsMainContainer">
      {/* { loader && <SpinnerModel
                  value={""}
                  color={"primary"}
                  size={""}
                  type={"border"}
                />} */}
      <div className="caseDocumentSearch">
        <input
          type="text"
          id="search"
          value={caseDocumentsSearch}
          onChange={handleCaseDocumentsSearch}
          placeholder={`Search`}
        />
      </div>
      <div className="caseDocuments">
        {caseDocuments?.length > 0 ? (
          caseDocuments?.map((each: ICaseDocumentModel) => (
            <div
              key={each?.caseDocMappingId}
              className="caseDocumentsInner"
              onClick={() => fileViewerHandler(each?.caseDocMappingId)}
            >
              <img src={PDFIcon} alt="PDFIcon" />
              <span className="docName">{each?.documentName || "--"}</span>
            </div>
          ))
        ) : (
          <h6 className="not-available">No Documents Available</h6>
        )}
      </div>
      <div className="fileViewerModalContainer caseDocuments">
        <Modal
          className=" mw-100 w-50 fileViewerModalWrapper"
          isOpen={fileViewerToShow}
          fade={false}
        // toggle={fileViewerHandler}
        >
          <ModalHeader toggle={cancelFileViewHandler}>
            <Row className="customHeader modal-title">
              <Col>
                <div className="fileHeader">{file?.fileName} </div>
              </Col>
            </Row>
            <Row></Row>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {file ?
                (
                  <FileViewer
                    fileDocument={file}
                  />
                  // <FileViewer 
                  // files={[file]}
                  // disableHeader={true}
                  // />
                )
                : (
                  ""
                )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default CaseDocuments;
